<div class="page">
    <div class="page__header">
        <custom-app-bar [hasCloseButton]="true"></custom-app-bar>
    </div>

    <div class="page__content">

        <p class="header2">{{ 'contact.title' | translate}}</p>
        <p class="text">{{ 'contact.text_1' | translate}}</p>

        <custom-button class="button-call">
            <a href="tel:+34900118888" target="_blank" rel="noopener">{{'contact.button_call' | translate}}</a>
        </custom-button>

        <p class="text text-form">{{ 'contact.text_2' | translate}}</p>

        <form class="contact-form" (ngSubmit)='onSubmit()' [formGroup]="contactForm">

            <div class="phone-form-field-group">
                <custom-selector-field
                        class="phone-form-field"
                        [optionList]="(phonePrefixesOptions$ | async) ?? []"
                        [controlName]="'phonePrefix'"
                        [formGroup]="contactForm"
                        [shouldDisplayErrorMessage]="false"
                ></custom-selector-field>

                <custom-form-field
                        class="form-field"
                        [type]="'tel'"
                        [label]="'contact.phone' | translate"
                        [controlName]="'phone'"
                        [formGroup]="contactForm"></custom-form-field>
            </div>


            <custom-form-field
                    [type]="'text'"
                    [kind]="'text_area'"
                    [label]="'contact.message' | translate"
                    [controlName]="'message'"
                    [formGroup]="contactForm"></custom-form-field>
        </form>
    </div>

    <div class="page__footer">
        <button
                customButton
                [disabled]="(isContactLoading$ | async) || !contactForm.valid"
                [isLoading]="isContactLoading$ | async"
                type="submit"
                appearance="ghost"
                expand="full"
                size="large"
                (click)="onSubmit()">
            {{'contact.button_send' | translate}}
        </button>
    </div>

</div>
